// @flow
export const getFormattedOptionsFromOptionsArray = (options) => {
  const optionsToUse = [];

  for (const option of options) {
    const currOptionToPush = {
      key: option.name,
      text: option.display_name,
      value: option.name,
    };

    if (option.onClick) {
      currOptionToPush.onClick = option.onClick;
    }

    if (option.label) {
      currOptionToPush.label = option.label;
    }

    if (option.content) {
      currOptionToPush.content = option.content;
    }

    if (option.shouldNotBeSelectable) {
      currOptionToPush.disabled = true;
    }
    optionsToUse.push(currOptionToPush);
  }

  return optionsToUse;
};

export const getAllEnabledOptionsNamesFromAllOptions = (options) => {
  const enabledOptions = options.filter((x) => !x?.shouldNotBeSelectable);
  return enabledOptions.map((x) => x.name);
};

export const setFieldValueToGivenStringAndFieldTouchedToTrue = async (
  fieldName,
  fieldValue,
  setFieldValue,
  setFieldTouched
) => {
  await setFieldValue(fieldName, fieldValue);
  await setFieldTouched(fieldName, true);
};
